import { render, staticRenderFns } from "./SimTypeComponent.vue?vue&type=template&id=07161b21&scoped=true&"
import script from "./SimTypeComponent.vue?vue&type=script&lang=ts&"
export * from "./SimTypeComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SimTypeComponent.vue?vue&type=style&index=0&id=07161b21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07161b21",
  null
  
)

export default component.exports